import { OfficeSchedule } from '@modules/sub-accounts/sub-accounts.types';

export const BUSINESS_HOURS_SETTINGS_SECTION = 'businessHours';

export const WEEKDAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;

export type WeekdayName = (typeof WEEKDAY_NAMES)[number];

export interface OfficeScheduleDayForm {
  displayName: WeekdayName;
  open: boolean;
  startTime: string;
  endTime: string;
}

export function toTimeInputValue(time?: string | null): string {
  if (!time) {
    return '07:30';
  }
  return time.slice(0, 5);
}

export function toApiTimeValue(time: string): string {
  return time.length === 5 ? `${time}:00` : time;
}

export function officeScheduleToDayForms(officeSchedule: OfficeSchedule[] = []): OfficeScheduleDayForm[] {
  return WEEKDAY_NAMES.map((displayName) => {
    const entry = officeSchedule.find(schedule => schedule.displayName === displayName);
    const hasHours = !!(entry?.startTime && entry?.endTime);

    return {
      displayName,
      open: hasHours,
      startTime: toTimeInputValue(entry?.startTime),
      endTime: toTimeInputValue(entry?.endTime || '17:00:00'),
    };
  });
}

export function dayFormsToOfficeSchedule(days: OfficeScheduleDayForm[]): OfficeSchedule[] {
  return days
    .filter(day => day.open && day.startTime?.trim() && day.endTime?.trim())
    .map(day => ({
      displayName: day.displayName,
      startTime: toApiTimeValue(day.startTime),
      endTime: toApiTimeValue(day.endTime),
    }));
}

export function matchesSubAccountIdentifier(
  subAccount: { subAccountUID?: string; _id?: string },
  identifier?: string | null
): boolean {
  if (!identifier) {
    return false;
  }

  return subAccount.subAccountUID === identifier || subAccount._id === identifier;
}

export function formatOfficeScheduleSummary(officeSchedule: OfficeSchedule[] = []): string {
  if (!officeSchedule.length) {
    return '';
  }

  return officeSchedule
    .map(({ displayName, startTime, endTime }) => {
      const start = toTimeInputValue(startTime);
      const end = toTimeInputValue(endTime);
      return `${displayName} ${start}-${end}`;
    })
    .join(', ');
}
